import { Col, Empty, Space, Tag, Typography } from "antd";
import { ClaimKanbanCard } from "./ClaimKanbanCard";
import type { Claim } from "@rumble-it/common-lib/types/models/Claim.interface";

const { Title } = Typography;

interface KanbanLaneProps {
  title: string;
  claims: Claim[];
  /** Accent color shown as a top border on the lane */
  groupColor?: string;
}

export const ClaimKanbanLane = ({
  title,
  claims,
  groupColor,
}: KanbanLaneProps) => {
  return (
    <Col xs={24} sm={24} md={16} lg={12} xl={8} xxl={6}>
      <div className="flex flex-col h-[calc(100vh-240px)] border border-gray-200 rounded-xl overflow-hidden bg-white mb-3">
        {/* Colored top border indicating the lane group */}
        <div
          style={{
            height: 4,
            backgroundColor: groupColor ?? "#d9d9d9",
            borderRadius: "12px 12px 0 0",
          }}
        />

        <div className="sticky top-0 z-10 bg-white border-b border-gray-200 p-3">
          <Space className="w-full justify-between" align="center">
            <Space align="center" size={8}>
              {/* Small colored dot matching the group accent */}
              <span
                style={{
                  display: "inline-block",
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: groupColor ?? "#d9d9d9",
                  flexShrink: 0,
                }}
              />
              <Title level={5} style={{ margin: 0 }}>
                {title}
              </Title>
            </Space>
            <Tag bordered={false} className="bg-gray-100 rounded-full">
              {claims.length}
            </Tag>
          </Space>
        </div>
        <div style={{ padding: 12, overflow: "auto" }}>
          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            {claims.length ? (
              claims.map((claim) => (
                <ClaimKanbanCard key={claim.id} claim={claim} />
              ))
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Geen dossiers aanwezig"
              />
            )}
          </Space>
        </div>
      </div>
    </Col>
  );
};
